"use client";
import { StytchProvider as ProviderActual } from "@stytch/nextjs";
import { createStytchHeadlessClient } from "@stytch/nextjs/headless";
import type { ReactNode } from "react";

const stytchOptions = {
  cookieOptions: process.env.NEXT_PUBLIC_COOKIE_DOMAIN
    ? {
        path: "/",
        availableToSubdomains: true,
        domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
      }
    : {
        path: "/",
        avalableToSubdomains: false,
      },
};

// We initialize the Stytch client using our project's public token which can be found in the Stytch dashboard
const stytch = createStytchHeadlessClient(
  process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN || "",
  stytchOptions,
);

const StytchProvider = ({ children }: { children: ReactNode }) => {
  return <ProviderActual stytch={stytch}>{children}</ProviderActual>;
};

export default StytchProvider;
